<template lang="pug">
  v-card
    v-card-title
      h2.modal-title {{ 'base.add_company' | translate }}
    v-card-content
      v-input-r(
        ref="nameInput"
        :label="$t('base.company_name_2')"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        :pattern="'.{1,100}'"
        v-model="form.name"
        @blur="validateName")
    v-card-actions
      v-btn(
        :disabled="!form.name"
        :loading="loading"
        @click="onCreate")
        | {{ 'base.add' | translate }}
</template>

<script>
import { mapActions } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
export default {
  name: 'CreateModal',

  data: () => ({
    form: {
      name: null
    },
    errors: {
      name: null
    },
    loading: false
  }),
  mixins: [formErrorsMixin],

  watch: {
    'form.name' (newValue) {
      if (this.errors.name && newValue && newValue.length > 0 && newValue.length <= 100) {
        this.errors.name = null
      }
    }
  },

  methods: {
    ...mapActions('companies', [
      'createCompany'
    ]),

    validateName () {
      this.checkValidData()
    },

    forceValidation () {
      this.checkValidData()

      if (this.errors.name) {
        const inputComponent = this.$children.find(child => child.$options.name === 'VInputR')
        if (inputComponent) {
          inputComponent.hasBlurred = true
        }
      }
    },

    async onCreate () {
      this.forceValidation()

      if (this.errors.name !== null) {
        return
      }

      this.loading = true
      const payload = {
        name: this.form.name
      }

      const error = await this.createCompany(payload)
      if (!error) {
        this.$emit('update')
        this.$emit('close')
      } else {
        this.$toasted.error(this.$t('errors.incorrect_data'))
      }
      this.loading = false
    },

    checkValidData () {
      this.errors.name = null

      if (!this.form.name) {
        this.errors.name = ['3']
      } else if (this.form.name.length > 100) {
        this.errors.name = ['6', 100]
      }
    }
  }
}
</script>
<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
}

.v-card__actions button {
  width: 100%;
}
</style>